import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { getPartnerPlayers } from '../../services'
import { PartnerQueryKeys } from '@/modules/manage-player/keys'
import {
	GetPartnerPlayersRequest,
	GetPartnerPlayersResponse,
} from '@/modules/manage-player/type'

export default function useQueryGetPartnerPlayers(
	partnerId: string,
	payload: GetPartnerPlayersRequest,
	props?: UseBaseQueryOptions<GetPartnerPlayersResponse>,
) {
	return useQuery({
		queryKey: [PartnerQueryKeys.GetPartnerPlayers, partnerId, payload],
		queryFn: () => getPartnerPlayers(partnerId, payload),
		enabled: !!partnerId,
		...props,
	})
}
